import { render, staticRenderFns } from "./AssetsTabletsAreaDetails.vue?vue&type=template&id=2ebdd5c6&"
import script from "./AssetsTabletsAreaDetails.vue?vue&type=script&lang=js&"
export * from "./AssetsTabletsAreaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports